import { render, staticRenderFns } from "./v2default.vue?vue&type=template&id=2f9f194f&scoped=true&"
import script from "./v2default.vue?vue&type=script&lang=js&"
export * from "./v2default.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9f194f",
  null
  
)

export default component.exports